import './ActivityFeedCidSelect.scss';
import { ReactNode, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MAX_ORACLE_CIDS } from '@blisspointmedia/bpm-types/dist/OracleApi';
import { EmptyState } from '@Components/EmptyState/EmptyState';
import { Button } from '@Components/Button';
import { clientsToParams } from './Filters/activity-feed-filters-utils';
import { ActivityFeedClientDropdown } from './ActivityFeedClientDropdown';

export const ActivityFeedCidSelect = (): ReactNode => {
  const [, setSearchParams] = useSearchParams();
  const [selectedCids, setSelectedCids] = useState<string[]>([]);

  const isSelectionValid = selectedCids.length > 0 && selectedCids.length <= MAX_ORACLE_CIDS;

  const handleConfirm = () => {
    setSearchParams(
      params => {
        const next = new URLSearchParams(params);
        clientsToParams(next, selectedCids);
        return next;
      },
      { replace: true }
    );
  };

  return (
    <EmptyState
      className='activity-feed-cid-select'
      title='Select clients to view'
      subtitle={`Choose up to ${MAX_ORACLE_CIDS} clients to load their activity feed.`}
    >
      <ActivityFeedClientDropdown
        value={selectedCids}
        onChange={setSelectedCids}
        placeholder='Select clients'
        clearable
      />
      <Button
        className='activity-feed-cid-select-confirm'
        onClick={handleConfirm}
        disabled={!isSelectionValid}
      >
        View Activity Feed
      </Button>
    </EmptyState>
  );
};
